export const TeamRole = {
  ROLE_VENDOR_OWNER: 'ROLE_VENDOR_OWNER',
  ROLE_VENDOR_HANDLER: 'ROLE_VENDOR_HANDLER'
};
